// Shared helpers so the signed-in user's role is presented consistently
// across every portal (Client / BD / Admin top bars + profile screen).

export type UserRole =
  | "Admin"
  | "Supervisor"
  | "Sales Director"
  | "Business Developer"
  | "Client"
  | "Finance User";

// Short, human label for the role chip.
export const roleLabel = (role?: string): string => {
  switch (role) {
    case "Business Developer":
      return "Business Developer";
    case "Sales Director":
      return "Sales Director";
    case "Finance User":
      return "Finance";
    case "Admin":
      return "Admin";
    case "Supervisor":
      return "Supervisor";
    case "Client":
      return "Client";
    default:
      return role || "—";
  }
};

// Which portal the role belongs to — the immediately-visible grouping the spec asks for.
export const rolePortal = (role?: string): "Admin" | "BD" | "Client" | "Finance" => {
  if (role === "Client") return "Client";
  if (role === "Business Developer") return "BD";
  if (role === "Finance User") return "Finance";
  return "Admin"; // Admin, Supervisor, Sales Director are admin-side portals
};

// Tailwind classes for the role badge, colour-coded per portal.
export const roleBadgeClass = (role?: string): string => {
  switch (rolePortal(role)) {
    case "Client":
      return "bg-violet-100 text-violet-700 ring-violet-200";
    case "BD":
      return "bg-blue-100 text-blue-700 ring-blue-200";
    case "Finance":
      return "bg-emerald-100 text-emerald-700 ring-emerald-200";
    default:
      return "bg-amber-100 text-amber-700 ring-amber-200";
  }
};
